import { useState } from 'react';
import '../css_files/warningBox.css';

interface ConfirmDialogProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string | React.ReactNode;
    onConfirm?: (inputText?: string) => void;
    button1?: string;
    showbutton2?: boolean;
    button2?: string;
    showTextInput?: boolean;
    textPlaceholder?: string;
    button2Color?: 'red' | 'green';
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    button1 = 'Cancel',
    showbutton2 = true,
    button2 = 'Delete',
    showTextInput = false,
    textPlaceholder = '',
    button2Color = 'red',
}) => {
    const [inputText, setInputText] = useState('');

    if (!isOpen) return null;

    const handleConfirm = () => {
        // Closing (and clearing the typed text) is left to the caller's onConfirm
        // handler, which may be async and need to keep the dialog open on failure
        // so the user can retry without losing what they typed.
        if (onConfirm) {
            onConfirm(inputText);
        }
    }

    const handleClose = () => {
        onClose();
        setInputText('');
    };

    const getButtonColorClass = () => {
        switch (button2Color) {
            case 'green':
                return 'confirm-dialog-confirm-green';
            case 'red':
            default:
                return 'confirm-dialog-confirm';
        }
    };

    return (
        <div className="confirm-dialog-overlay">
            <div className="confirm-dialog-content">
                <h2>{title}</h2>
                <p>{message}</p>

                {showTextInput && (
                    <div className="confirm-dialog-reason">
                        <textarea
                            value={inputText}
                            onChange={(e) => setInputText(e.target.value)}
                            placeholder={textPlaceholder}
                            className="confirm-dialog-reason-input"
                            rows={3}
                        />
                    </div>
                )}

                <div className="confirm-dialog-buttons">
                    <button
                        onClick={handleClose}
                        className="confirm-dialog-cancel"
                    >
                        {button1}
                    </button>
                    {showbutton2 && (
                        <button 
                            onClick={handleConfirm}
                            className={`confirm-dialog-confirm ${getButtonColorClass()}`}
                        >
                            {button2}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
